import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fbc0a84"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pagination",
  role: "navigation"
}
const _hoisted_2 = {
  key: 0,
  class: "first"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 1,
  class: "prev"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 2,
  class: "page"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "page current" }
const _hoisted_9 = {
  key: 3,
  class: "page"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 4,
  class: "next"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  key: 5,
  class: "last"
}
const _hoisted_14 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.last > 1)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        (_ctx.current !== 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createElementVNode("a", {
                href: _ctx.pagePath(1)
              }, "«", 8, _hoisted_3)
            ]))
          : _createCommentVNode("", true),
        (_ctx.current !== 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _createElementVNode("a", {
                href: _ctx.pagePath(_ctx.current - 1),
                rel: "prev"
              }, "‹", 8, _hoisted_5)
            ]))
          : _createCommentVNode("", true),
        (_ctx.current > 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
              _createElementVNode("a", {
                href: _ctx.pagePath(_ctx.current - 1)
              }, _toDisplayString(_ctx.current - 1), 9, _hoisted_7)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.current), 1),
        (_ctx.current < _ctx.last)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
              _createElementVNode("a", {
                href: _ctx.pagePath(_ctx.current + 1)
              }, _toDisplayString(_ctx.current + 1), 9, _hoisted_10)
            ]))
          : _createCommentVNode("", true),
        (_ctx.current !== _ctx.last)
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
              _createElementVNode("a", {
                href: _ctx.pagePath(_ctx.current + 1),
                rel: "next"
              }, "›", 8, _hoisted_12)
            ]))
          : _createCommentVNode("", true),
        (_ctx.current !== _ctx.last)
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
              _createElementVNode("a", {
                href: _ctx.pagePath(_ctx.last)
              }, "»", 8, _hoisted_14)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}